import * as React from 'react';

import { cn } from '@/lib/utils';

const Card = React.forwardRef<HTMLDivElement, React.ComponentProps<'div'>>(
  ({ className, ...props }, ref) => (
    <div
      data-slot="card"
      className={cn(
        'rounded-2xl border border-slate-100 bg-white p-5',
        className,
      )}
      ref={ref}
      {...props}
    />
  ),
);

Card.displayName = 'Card';

export { Card };
